import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 用户
 */
const user = {

  /**
   * 创建
   */
  createUser (account, password, nickname, gender, birthday) {
    return axios.post(base.user.createUser, utils.postParamsArrayToJsonString({ account, password, nickname, gender, birthday }))
  },
  /**
   * 查询用户信息
   */
  getUserInfo () {
    return axios.post(base.user.getUserInfo, utils.postParamsArrayToJsonString({ userId: 0 }))
  },
  /**
   * 修改信息
   */
  modifyUserInfo (nickname, gender, birthday) {
    return axios.post(base.user.modifyUserInfo, utils.postParamsArrayToJsonString({ nickname, gender, birthday }))
  },
  /**
   * 修改邮箱
   */
  modifyUserEmailAddress (emailAddress) {
    return axios.post(base.user.modifyUserEmailAddress, utils.postParamsArrayToJsonString({ emailAddress }))
  },
  /**
   * 修改手机号码
   */
  modifyUserPhoneNumber (authCode, phoneNumber) {
    return axios.post(base.user.modifyUserPhoneNumber, utils.postParamsArrayToJsonString({ authCode, phoneNumber }))
  },
  /**
   * 修改密码
   */
  modifyUserPassword (oldPassword, newPassword) {
    return axios.post(base.user.modifyUserPassword, utils.postParamsArrayToJsonString({ oldPassword, newPassword }))
  },
  /**
   * 重置密码
   */
  resetUserPassword (userId, notifyBy, loginPassword) {
    return axios.post(base.user.resetUserPassword, utils.postParamsArrayToJsonString({ userId, notifyBy, loginPassword }))
  },
  /**
   * 查询用户原始前端页面权限
   */
  getUserOriginFrontEndPagePrivileges (userId) {
    return axios.post(base.user.getUserOriginFrontEndPagePrivileges, utils.postParamsArrayToJsonString({ userId }))
  },
  /**
   * 设置用户原始前端页面权限
   */
  setUserOriginFrontEndPagePrivileges (userId, pages) {
    return axios.post(base.user.setUserOriginFrontEndPagePrivileges, utils.postParamsArrayToJsonString({ userId, pages }))
  },
  /**
   * 查询我创建的公司
   */
  listCompaniesOfICreated (startTime, endTime) {
    return axios.post(base.user.listCompaniesOfICreated, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
  /**
   * 查询我加入的公司
   */
  listCompaniesOfIJoined(startTime, endTime, onlyDirect) {
    return axios.post(base.user.listCompaniesOfIJoined, utils.postParamsArrayToJsonString({ startTime, endTime, onlyDirect }))
  },
  // 查询我有权访问的公司
  getAccessibleCompany(startTime='', endTime='') {
    return axios.post(base.user.getAccessibleCompany, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
}

export default user